module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleCloseTree),
      expression: "handleCloseTree"
    }],
    ref: "atsTree",
    staticClass: "ats-tree"
  }, [_c('div', {
    staticClass: "ats-input",
    on: {
      "mouseenter": function($event) {
        _vm.hovering = true
      },
      "mouseleave": function($event) {
        _vm.hovering = false
      }
    }
  }, [(!this.multiple) ? _c('div', {
    staticClass: "ats-input-single"
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-caret-bottom",
    class: {
      'is-reverse': _vm.treeVisible, 'el-icon-circle-close': _vm.showCloseIcon
    },
    on: {
      "click": function($event) {
        return _vm.handleCloseTree(!_vm.treeVisible)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.treeSelected),
      expression: "treeSelected"
    }],
    staticClass: "el-input__inner",
    attrs: {
      "type": "text",
      "placeholder": _vm.placetext
    },
    domProps: {
      "value": (_vm.treeSelected)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.treeSelected = $event.target.value
      }, _vm.handleFilter],
      "focus": function($event) {
        _vm.treeVisible = true
      },
      "blur": _vm.handleAutoComplete
    }
  })]) : _vm._e(), _vm._v(" "), (this.multiple) ? _c('div', {
    staticClass: "ats-input-multiple el-input__inner"
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-caret-bottom",
    class: {
      'is-reverse': _vm.treeVisible
    },
    on: {
      "click": function($event) {
        return _vm.handleCloseTree(!_vm.treeVisible)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ats-labels"
  }, [_c('div', {
    staticClass: "el-select__tags",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleCloseTree(true)
      }
    }
  }, _vm._l((_vm.checkedItems), function(item) {
    return _c('el-tag', {
      key: item[_vm.treeProps.id],
      staticClass: "el-tag--primary",
      attrs: {
        "closable": true,
        "type": "primary",
        "title": _vm.handleTitleVisible(item[_vm.treeProps.label])
      },
      on: {
        "close": function($event) {
          return _vm.handleDelItem(item, $event)
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm._f("showEllips")(item[_vm.treeProps.label])) + "\n          ")])
  }), 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.treeSelected),
      expression: "treeSelected"
    }],
    ref: "multipleInput",
    attrs: {
      "type": "text",
      "placeholder": _vm.placetext
    },
    domProps: {
      "value": (_vm.treeSelected)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.treeSelected = $event.target.value
      }, _vm.handleFilter],
      "focus": function($event) {
        _vm.treeVisible = true
      },
      "blur": _vm.handleAutoComplete
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('el-scrollbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.treeVisible),
      expression: "treeVisible"
    }],
    ref: "treeScrollbar",
    staticClass: "ats-tree-scrollbar"
  }, [_c('div', {
    staticClass: "ats-tree-wrapper"
  }, [_c('ul', {
    staticClass: "ats-tree-nodes"
  }, _vm._l((_vm.treeNodes[_vm.treeProps.children]), function(child) {
    return _c('tree-node', {
      key: child[_vm.treeProps.id],
      attrs: {
        "node": child,
        "multiple": _vm.multiple,
        "currentNodeId": _vm.currentNodeId,
        "treeProps": _vm.treeProps,
        "eventHub": _vm.eventHub,
        "query": _vm.query,
        "isQuering": _vm.isQuering
      }
    })
  }), 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-5d53c784","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/libcomponents/tree-select/tree.vue
// module id = 770
// module chunks = 1